import { Alert, Autocomplete, Box, InputAdornment, List, Popper, TextField, Tooltip } from "@mui/material";
import { ReactNode, SyntheticEvent, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import DriverAvatar from "@/components/DriverAvatar";
import useDriversContext from "@/providers/data/DriversContext";
import { User } from "@/types/user.types";

import { useDriverStatusContext } from "../../DriverStatusContext";

function DriverStatusVisibilityFilter() {
    const { t } = useTranslation();
    const { allDrivers } = useDriversContext();
    const { hiddenDrivers, handleHiddenDrivers, loading } = useDriverStatusContext();
    const handleDriverChange = useCallback(
        (_: SyntheticEvent<Element, Event>, selectedDrivers: User[]) => {
            const driverIds = selectedDrivers.map((driver) => driver.id);
            handleHiddenDrivers(driverIds);
        },
        [handleHiddenDrivers]
    );
    const selectedDrivers = useMemo(
        () => allDrivers.filter((driver) => hiddenDrivers.includes(driver.id)),
        [hiddenDrivers, allDrivers]
    );
    return (
        <Autocomplete
            disableCloseOnSelect
            PopperComponent={(props) => {
                return (
                    <Popper {...props} placement="bottom-start">
                        <div>
                            <List component="div" {...props}>
                                {props.children as ReactNode}
                            </List>
                            <Alert severity="info" color="info">
                                {t("infos.selectDriversYouWanttoHide")}
                            </Alert>
                        </div>
                    </Popper>
                );
            }}
            classes={{
                inputRoot: " !h-[47px] !min-w-72",
            }}
            sx={() => ({
                "label + &": {
                    marginTop: 20,
                },
                "& .MuiInputBase-input": {
                    paddingBottom: 12,
                    paddingTop: 12,
                },
            })}
            value={selectedDrivers}
            multiple
            options={allDrivers}
            disabled={loading}
            getOptionLabel={(option) => option.name}
            onChange={handleDriverChange}
            renderOption={(props, { name, isDeleted }) => {
                const { key, ...optionProps } = props;

                return (
                    <Box
                        key={key}
                        component="li"
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        {...optionProps}
                    >
                        <DriverAvatar avatar name={name} isDeleted={isDeleted} />
                    </Box>
                );
            }}
            renderInput={(params) => {
                return (
                    <TextField
                        {...params}
                        placeholder={t("driverVisibility")}
                        variant="filled"
                        sx={{
                            "& .MuiInputBase-input": {
                                transform: "translateY(-10px)",
                            },
                        }}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                <Tooltip title="Gizlenen Sürücü Sayısı">
                                    <InputAdornment
                                        position="end"
                                        className="    cursor-help !-translate-x-2 !font-semibold !-translate-y-3 !w-12 !h-full !flex !items-center !bg-gray-300 !justify-center"
                                    >
                                        {hiddenDrivers.length}
                                    </InputAdornment>
                                </Tooltip>
                            ),
                        }}
                    />
                );
            }}
        />
    );
}

export default DriverStatusVisibilityFilter;
